<app-main-layout>
  <div class="main-heading large">
    <h2>
      Unfortunately, it looks like you're outside our service area{{name ? ', ' + name : ''}}.
    </h2>
    <div class="cs-inner-html-18">
      @if (brandKey === 'newsouth') {
        <p>We are frequently expanding into new areas, so please keep us in mind for your future needs. In the meantime, for further information, please contact us at <a href="tel:8666385831">(866) 638-5831</a>.</p>
      } @else if (brandKey === 'armorvue') {
        <p>We are frequently expanding into new areas, so please keep us in mind for your future needs. In the meantime, for further information, please contact us at <a href="tel:8442778752">(844) 277-8752</a>.</p>
      } @else {
        <p>We are frequently expanding to new areas, so please keep us in mind for your future needs. In the meantime, here are some useful links to help you with your window/door shopping.</p>
      }
    </div>
  </div>
  @if (brandKey !== 'newsouth' && brandKey !== 'armorvue') {
    <div class="blog-posts">
      <h3 class="h5-m">Online Resource Spotlight</h3>
      <div class="blog-posts-frame">
        @for (card of blogPosts; track card) {
          <app-blog-post-card [card]="card" />
        }
      </div>
    </div>
  }
</app-main-layout>
